/**
 * This wrapper makes sure that the children are only rendered when they enter the viewport,
 * aka become visible.  When the component leaves the viewport, it is removed from the DOM.
 */

import { useLayoutEffect, useRef, useState } from "react";
import { className as classNameBuilder } from "@/common/utils";

interface IProps {
  children: React.ReactNode;
  className?: string;
}

export const VisibleOnly = ({ className, children }: IProps) => {
  const [isVisible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!ref.current) {
      console.debug("ref not set");
      return;
    }

    const options = {
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setVisible(entry.isIntersecting);
      });
    }, options);

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return <div className={classNameBuilder({
    [className ?? ""]: true,
    VisibleOnly: true,
  })} ref={ref}>{isVisible ? children : null}</div>;
};
